var map = {
	"./img6-chs.png": 388,
	"./img6-cht.png": 416,
	"./img6-kor.png": 417,
	"./img6-usa.png": 418
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 415;



//////////////////
// WEBPACK FOOTER
// ./images/indexV2 ^\.\/img6\-.*\.png$
// module id = 415
// module chunks = 0